import React from 'react';

function Choir() {
	return (
		<div>CHOIR</div>
	);
};

export default Choir;
